import {useGridTableStore} from "@/store/modules/gridTableStore";
import {GoingNewUtils} from 'xmgoing-utils';
import {ref, unref} from "vue";

export function useGridTableStoreCtl({props,dataConfig,ctlType}){
  const gridTableStore: any = useGridTableStore();

  const initStoreCtl=function (initCtlDataFun:any){
    //注册对象
    if (unref(dataConfig)) {
      gridTableStore.registerCtl({props: unref(props), dataConfig:unref(dataConfig),ctlType});
    }else{
      gridTableStore.registerCtl({props: unref(props), dataConfig: {moduleName:GoingNewUtils.getUUChar(20),tableCode:GoingNewUtils.getUUChar(20)},ctlType});
    }

    //获取对象
    const tableObj = ref(gridTableStore.getGridObjByKey(unref(props).key));
    if (unref(tableObj)) {
      /**
       * 监听属性变化
       */
      watch(() => unref(tableObj)['flushGrid'], (newDatas) => {
        initCtlDataFun&&initCtlDataFun({...unref(tableObj).queryParams});
      })
    }
  }

  return {
    initStoreCtl
  }
}
